export const SETTINGS_TITLE = {
  ALERTS: "Alerts",
  SITES: "Sites",
  USERS: "Users",
  ROLES: "Roles",
  SUPPORT: "Support",
  LICENSES: "Licenses",
  ENROLLED_APPEARANCE: "Enrolled Appearance"
}

export const SETTINGS_DESCRIPTION = {
  ALERTS: "Create multi-camera alerts and view existing alerts",
  SITES: "Manage your sites and floor plans",
  USERS: "View users and create user groups for alerts",
  ROLES: "Manage the role types within your organization",
  SUPPORT: "Find collateral and support contact details",
  LICENSES: "View and change licenses",
  ENROLLED_APPEARANCE: "Configure the ability to detect uniforms and other clothing indicating an employee"
}

export const SETTINGS_ICONS = {
  ALERTS: "reports-and-alerts",
  SITES: "location",
  USERS: "group-family",
  ROLES: "user-settings",
  SUPPORT: "support-drawer",
  LICENSES: "cards-on-reserve",
  ENROLLED_APPEARANCE: "user"
}

export const NOTIFICATION_TYPES = {
  WARNING: "warning",
  MESSAGE: "Sorry, this page is under construction. Please come back later!",
};

export const PERMISSION_TYPES = {
  SITES: "Site management",
  USERS: "User management",
  ROLES: "Role management",
  ALERTS: "Alerts",
  LICENSES: "License management",
};

export const VIEW_TEXT = "View"